<template>
  <div>
    <div class="col-md-6 form">
      <div class="body">
        <slot name="body"/>
      </div>
      <div
        v-if="showFooter"
        class="footer">
        <div class="text">
          <slot name="footer-text"/>
        </div>
        <div class="actions">
          <slot name="footer-actions"/>
        </div>
      </div>
    </div>
    <div
      v-if="showSecured"
      class="secure">
      <span>
        <i class="fas fa-lock"/>
        Secured by
      </span>
      <img src="@/assets/images/logo/omise.png">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
    },
    showSecured: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    showFooter () {
      return this.$slots['footer-text'] || this.$slots['footer-actions']
    },
  },
}
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
  padding: 0;
  max-width: 760px;
  margin: auto;
  background: #FFF;
  border-radius: 2px;
}

.body {
  padding: 18px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 18px;
  border-top: solid 1px #E6E6E6;
}

.footer .text {
  display: flex;
  align-items: center;
}

.footer .actions {
  display: flex;
  align-items: center;
}

.secure {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0 50px 0;
}

.secure span {
  margin-right: 4px;
  font-size: 12px;
  font-weight: bold;
  color: #2e384c;
}

.secure img {
  height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BasePaymentForm.vue